// src/utilities/has-correct-parent.ts
var hasCorrectParent = (el, parentTagName, logError = true) => {
  var _a;
  const parentHasCorrectTag = ((_a = el.parentElement) == null ? void 0 : _a.tagName.toLowerCase()) === parentTagName.toLowerCase();
  if (logError && !parentHasCorrectTag) {
    console.error(`${el.tagName.toLowerCase()} is not supposed to live outside of ${parentTagName.toLowerCase()}`);
  }
  return parentHasCorrectTag;
};

export {
  hasCorrectParent
};
